import { AxiosResponse } from "axios";
import { MERCHANT_V3_API_URLS as M3_API } from "@/apps/merchant3/services/apiClient/apiUrl";
import { jwtApiClient } from "@/apps/merchant3/services/apiClient/apiClient";
import { ICustomerWrap } from "@/types/customer";
import { ICustomerNote } from "@/apps/merchant3/types/customer-registration/customer-contact-info";

export const getCustomer = async (
  userTag: string
): Promise<AxiosResponse<ICustomerWrap>> => {
  return await jwtApiClient.get(M3_API(userTag).CUSTOMER);
};

export const createCustomer = async (
  personRegistrationTag: string,
  cartTag: string
): Promise<AxiosResponse<ICustomerWrap>> => {
  return await jwtApiClient.post(
    M3_API().CREATE_CUSTOMER,
    {},
    {
      params: {
        personRegistrationTag,
        cartTag,
      },
      headers: {
        Prefer: "code=200, example=default",
      },
    }
  );
};

export const resetValidation = async (
  userTag: string
): Promise<AxiosResponse<ICustomerWrap>> => {
  return await jwtApiClient.get(M3_API(userTag).RESET_VALIDATION);
};

export const createCustomerNote = async (
  customerNote: ICustomerNote
): Promise<AxiosResponse<unknown>> => {
  return await jwtApiClient.post(M3_API().STORE_USER_NOTE, customerNote, {
    headers: {
      Prefer: "code=200, example=default",
    },
  });
};
